<ion-header class="order-header" color="primary">
    <ion-toolbar>
        <ion-buttons slot="start">
            <custom-back-button (backButtonClick)="backButtonClick()"></custom-back-button>
        </ion-buttons>
        <ion-title *ngIf="store && this.orderService.isCourt">
            <ion-select okText="Okay!" (ionChange)="goStore()" [(ngModel)]="selectedValue" interface="popover"
                placeholder="{{store?.name}}">
                <template *ngFor="let store of stores">
                    <ion-select-option value="{{store.id}}">
                        {{store.name}}
                    </ion-select-option>
                </template>
            </ion-select>
        </ion-title>
        <!-- <ion-buttons slot="primary" *ngIf="orderService.isCourt">
            <ion-button (click)="homeButtonClick()" class="back-btn">
                <ion-icon name="home"></ion-icon>
            </ion-button>
        </ion-buttons> -->
        <ion-buttons slot="primary">
            <div  *ngIf="settings.enableSearch">
                <ion-button fill="clear" (click)="tapSearch()" class="search-btn">
                    <ion-icon name="md-search" class="h-nav-cart"></ion-icon>
                </ion-button>
            </div>
            <div class="h-nav">
                <ion-button fill="clear" (click)="cartClicked()">
                    <ion-icon name="md-cart" class="h-nav-cart">
                        <!-- <span *ngIf="!multOrderManager.enableMutlOrder && orderManager.getOrder().orderitems.length > 0" class="news"></span>
                        <span *ngIf="multOrderManager.enableMutlOrder && multOrderManager.getOrderCount() > 0" class="news"></span> -->
                    </ion-icon>
                    <ion-badge *ngIf="!multOrderManager.enableMutlOrder" id="notifications-badge" color="danger">
                        {{orderManager.count}}</ion-badge>
                    <ion-badge *ngIf="multOrderManager.enableMutlOrder" id="notifications-badge" color="danger">
                        {{multOrderManager.getOrderCount()}}</ion-badge>
                </ion-button>
            </div>
        </ion-buttons>
    </ion-toolbar>
    <ion-toolbar *ngIf="categories" transparent no-padding>
        <div class="cat-tab-wrapper">
            <ion-button fill="clear" *ngFor="let cat of categories" (click)="catClicked(fab, cat)"
                class="cat-tab AQA-Category" id="{{ cat.id == category.id ? 'active' : '' }}">
                <span>{{cat.name}}</span>
            </ion-button>
        </div>
        <!-- <div style="width: 140px;">
            <ion-slides>
                <ion-slide *ngFor="let cat of categories" (click)="catClicked(cat)" class="cat-tab" id="{{ cat.id == category.id ? 'active' : '' }}">
                        {{cat.name}}
                </ion-slide>
            </ion-slides>
        </div> -->
    </ion-toolbar>
</ion-header>

<ion-content fullscreen="true" class="item-grid-content"
    [ngClass]="{'dim-bg': isfabOpen , 'scrollLock' : isVariationOpened}" [scrollEvents]="isIonContentScroll"
    (ionScroll)="contentScrolling($event)">

   <!-- <div *ngIf="bannerImg" class="category-banner" [ngStyle]="{'background-image': 'url(' + bannerImg + ')'}">
        <div class="dim-bg"></div>
        <div class="cate-info">
            <p class="name">{{category.name}}</p>
            &lt;!&ndash; Desc Here &ndash;&gt;
            <p class="desc line-clamp"></p>
        </div>
    </div>-->

    <ng-container *ngFor="let cat of categories;let catIndex = index;" >
        <div *ngIf="displayCat[cat.id]" class="cat-content-box">
            
            <!-- 只显示一个cat -->
            <div *ngIf="!isInfiniteScroll">
                <ion-grid *ngIf="groups && mode == 'grid'" class="item-grid-wrapper grid2">
                    <ion-row>
                        <ion-col *ngFor="let item of displayCat[cat.id];let i = index" size="6">
                            <app-grid-layout-item (addClick)="addClicked(item)" (removeClick)="removeClicked(item)" [index]="i"
                                [item]="item" [category]="category" [imgs]="imgs" [tagsImage]="tagsImage"
                                [orderManager]="orderManager" [quantity]="orderManager.getQuantity(item)"
                                [currencySign]="orderManager?.store?.currencySign">
                            </app-grid-layout-item>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            
                <ion-grid *ngIf="groups && mode == 'grid3'" class="item-grid-wrapper grid3">
                    <ion-row>
                        <ion-col *ngFor="let item of displayCat[cat.id];let i = index" size="4">
                            <ion-card (click)="addClicked(item)"
                                [ngClass]="{'AQA-setItem': isSet(item), 'AQA-aLaCarteItem': !isSet(item)}"
                                class="item-wrapper animated fadeInUps grid3" ng-switch-when="category">
            
                                <div class="img-square center-cropped" style="background: white;">
            
                                    <div *ngIf="item.tags.length > 0" class="tag-image-box grid3">
                                        <div class="tag-images-wrapper">
                                            <ng-container *ngFor="let tagsImg of item.tags">
                                                <img *ngIf="tagsImage[tagsImg]" src="{{tagsImage[tagsImg]}}"
                                                    [ngClass]="{'single' : item.tags.length == 1}">
            
                                            </ng-container>
                                        </div>
                                    </div>
                                    <!-- <div *ngIf="item.tags.length > 0" [ngStyle]="{'background-image': 'url(' + getTagsImage(item) + ')'}"></div> -->
                                    <div class="item-img-box">
                                        <img src="{{imgs[i]}}" (error)="showEmpty(i)" />
                                    </div>
            
                                    <div class="sold-out-box AQA-soldOut" *ngIf="isSoldout(item)">
                                        <span>{{"pages.item-grid.soldout" | translate}}</span>
                                    </div>
            
                                    <div class="qty-panel" *ngIf="orderManager.getQuantity(item) > 0 && !isSet(item)">
                                        <ion-button fill="clear" class="btn-qty-remove AQA-minus-button" size="small"
                                            (click)="removeClicked(item);$event.stopPropagation();">
                                            <ion-icon name="md-remove"></ion-icon>
                                        </ion-button>
            
                                        <div class="qtn-with-item">
                                            <span>{{"global.quantity" | translate}}</span>
                                            <h5 class="AQA-item-qty">{{orderManager.getQuantity(item)}}</h5>
            
                                        </div>
                                        <ion-button fill="clear" size="small" class="btn-qty-add AQA-add-button">
                                            <ion-icon name="md-add"></ion-icon>
                                        </ion-button>
            
                                    </div>
            
                                </div>
                                <div class="item-info">
                                    <div class="item-price" *ngIf="!settings.hideZeroItemPrice || item.price > 0">
                                        <span *ngIf="!item.minPrice" class="itemPrice-text">
                                            {{orderManager?.store?.currencySign}}
                                            {{item | itemPrice}}
                                        </span>
                                        <span *ngIf="item.minPrice" class="itemPrice-text">
                                            {{orderManager?.store?.currencySign}}
                                            {{ item.minPrice | number : '1.0-2'}}
                                            {{"global.up" | translate}}
                                        </span>
                                        <!-- <span>{{orderManager?.store?.currencySign}}{{item.price | number : '1.0-2'}}</span> -->
                                        <ion-icon *ngIf="isSet(item)" class="icon-next" name="ios-arrow-forward"></ion-icon>
                                    </div>
                                    <div class="item-title">
                                        {{getItemName(item)}}
                                    </div>
            
                                </div>
                            </ion-card>
                        </ion-col>
            
                    </ion-row>
                </ion-grid>
            
            
                <ion-list *ngIf="groups && mode == 'list'" class="listMode">
                    <ion-item *ngFor="let item of displayCat[cat.id];let i = index" class="item-list-box animated fadeInUps"
                        (click)="addClicked(item)" [ngClass]="{'AQA-setItem': isSet(item), 'AQA-aLaCarteItem': !isSet(item)}">
            
                        <div *ngIf="isSoldout(item)" class="sold-out-box AQA-soldOut">
                            <p>{{"pages.item-grid.soldout" | translate}}</p>
                        </div>
            
                        <ion-thumbnail slot="end" *ngIf="getImage(item)">
                            <img src="{{getImage(item)}}">
                        </ion-thumbnail>
            
                        <!-- Action bar for Set -->
                        <div class="pre-quantity-box" *ngIf=" isSet(item) && orderManager.getQuantity(item) === 0" slot="end">
                            <ion-icon color="dark" name="arrow-forward"></ion-icon>
                        </div>
                        <!-- Action bar for A-la-carte -->
                        <div class="pre-quantity-box"
                            *ngIf=" !isSet(item) && (isRequiredModifier(item) ||(!store.menu.quickSingleItem && isModifiable(item))) "
                            slot="end">
                            <ion-icon color="dark" name="arrow-forward"></ion-icon>
                        </div>
            
            
                        <div class="pre-quantity-box"
                            *ngIf=" !isSet(item) && !isRequiredModifier(item) && (store.menu.quickSingleItem || !isModifiable(item)) && orderManager.getQuantity(item) === 0"
                            slot="end">
                            <ion-button fill="clear" class="aig-add-circle AQA-add-button">
                                <ion-icon name="add-circle-outline" color="success"></ion-icon>
                            </ion-button>
                        </div>
                        <div class="quantity-box"
                            *ngIf=" !isSet(item) && !isRequiredModifier(item) && (store.menu.quickSingleItem || !isModifiable(item)) && orderManager.getQuantity(item) > 0"
                            slot="end">
                            <ion-button fill="clear" class="aig-add-circle AQA-add-button">
                                <ion-icon name="add-circle-outline" color="success"></ion-icon>
                            </ion-button>
                            <ion-button fill="clear" (click)="removeClicked(item);$event.stopPropagation();"
                                class="aig-minus-circle AQA-minus-button">
                                <ion-icon name="remove-circle-outline" color="medium"></ion-icon>
                            </ion-button>
                        </div>
                        <div>
                            <div class="name-box">
                                <p class="name-text line-clamp">
                                    <ng-container *ngIf="orderManager.getQuantity(item) > 0">
                                        <span class="qty-text">{{orderManager.getQuantity(item)}}x </span>
                                    </ng-container>
                                    {{getItemName(item)}}
                                </p>
                                <div *ngIf="item.tags.length > 0" class="tag-image-box list">
                                    <ng-container *ngFor="let tagsImg of item.tags">
                                        <img *ngIf="tagsImage[tagsImg]" src="{{tagsImage[tagsImg]}}"
                                            [ngClass]="{'single' : item.tags.length == 1}">
                                    </ng-container>
                                </div>
                            </div>
            
                            <p class="desc-text line-clamp-3" *ngIf="item.desc AQA-itemDesc">{{ item.desc }}</p>
            
                            <div *ngIf="item.prefix.length > 0" class="tag-image-box prefix-box grid3">
                                <p *ngIf="item.price > 0 || !settings.hideZeroItemPrice" class="price-text itemPrice-text">
                                    {{orderManager?.store?.currencySign}}
                                    {{item | itemPrice}}
                                
                                </p>
                                <div class="tag-images-wrapper prefix-wrapper">
                                    <span>{{item.prefix}}</span>
                                </div>
                            </div>
            
                            <ng-container *ngIf="!(item.prefix && item.prefix.length > 0)">
            
                                <p *ngIf="item.price > 0 || !settings.hideZeroItemPrice" class="price-text itemPrice-text">
                                    <span *ngIf="!item.minPrice"
                                        class="itemPrice-text">{{orderManager?.store?.currencySign}}
                                        {{item | itemPrice}}</span>
                                    <span *ngIf="item.minPrice"
                                        class="itemPrice-text">{{orderManager?.store?.currencySign}}{{ item.minPrice | number : '1.0-2'}}
                                        {{"global.up" | translate}}</span>
                                </p>
            
                            </ng-container>
            
                            <!-- <p class="price-text" *ngIf="!settings.hideZeroItemPrice || item.price > 0">{{orderManager?.store?.currencySign}}{{ item.price | number : '1.0-2'}}</p> -->
                        </div>
            
                    </ion-item>
            
                </ion-list>
            </div>

            <!-- 根据滚动显示对应的cat -->
            <div *ngIf="isInfiniteScroll">
                <!-- mode = grid -->
                <ion-grid id="{{'cat'+catIndex}}" #catGrid2 class="item-grid-wrapper grid2" *ngIf="groups && getCatMode(cat) == 'grid'">
                    <ion-row>
                        <ion-text class="cat-tittle">{{cat.name}}</ion-text>
                        <ion-col *ngFor="let item of displayCat[cat.id];let i = index" size="6" #catItemGrid2>
                            <app-grid-layout-item (addClick)="addClicked(item)" (removeClick)="removeClicked(item)" [index]="i" [item]="item"
                                [category]="cat" [imgs]="imgsObj[cat.id]" [tagsImage]="tagsImage" [orderManager]="orderManager"
                                [quantity]="orderManager.getQuantity(item)" [currencySign]="orderManager?.store?.currencySign">
                            </app-grid-layout-item>
                        </ion-col>
                    </ion-row>
                </ion-grid>
                
                <!-- mode = list -->
                <ion-list id="{{'cat'+catIndex}}" #catList *ngIf="groups && getCatMode(cat) == 'list'" class="listMode">
                    <ion-text class="cat-tittle">{{cat.name}}</ion-text>
                    <ng-container *ngFor="let item of displayCat[cat.id]; let itemIdenx = index; let ItemLast = last">
                        <app-item (afterLastItemLoadJump)="afterLastItemLoadJump()" (removeClick)="removeClicked(item)"
                            (addClick)="addClicked(item)" [category]="cat" [item]="item" [last]="catLast && ItemLast"
                            [orderManager]="orderManager" [quantity]="orderManager.quantities[item.id]"></app-item>
                    </ng-container>
                </ion-list>
                
                <!-- mode = grid3 -->
                <ion-grid id="{{'cat'+catIndex}}" #catGrid3 class="item-grid-wrapper grid3" *ngIf="groups && getCatMode(cat) == 'grid3'">
                    <ion-row>
                        <ion-text #catTittleGrid3 class="cat-tittle">{{cat.name}}</ion-text>
                        <ion-col size="4" *ngFor="let item of displayCat[cat.id];let i = index">
                            <ion-card (click)="addClicked(item)" class="item-wrapper animated fadeInUps grid3"
                                ng-switch-when="category">
                                <div class="img-square center-cropped" style="background: white;">
                
                                    <div *ngIf="item.tags.length > 0" class="tag-image-box grid3">
                                        <div class="tag-images-wrapper">
                                            <ng-container *ngFor="let tagsImg of item.tags">
                                                <img *ngIf="tagsImage[tagsImg]" src="{{tagsImage[tagsImg]}}"
                                                    [ngClass]="{'single' : item.tags.length == 1}">
                
                                            </ng-container>
                                        </div>
                                    </div>
                                    <div class="item-img-box">
                                        <img src="{{imgsObj[cat.id][i]}}" (error)="showEmpty(i)" />
                                        <!-- <div class="item-price" *ngIf="!settings.hideZeroItemPrice || item-price > 0">
                                            <span>{{orderManager?.store?.currencySign}}{{item.price | number : '1.0-2'}}</span>
                                            <ion-icon *ngIf="isSet(item)" class="icon-next" name="ios-arrow-forward">
                                            </ion-icon>
                                        </div> -->
                                    </div>
                
                                    <div class="sold-out-box AQA-soldOut" *ngIf="isSoldout(item)">
                                        <span>{{"pages.item-grid.soldout" | translate}}</span>
                                    </div>
                
                                    <div class="qty-panel" *ngIf="orderManager.getQuantity(item) > 0 && !isSet(item)">
                                        <ion-button fill="clear" class="btn-qty-remove AQA-minus-button" size="small"
                                            (click)="removeClicked(item);$event.stopPropagation();">
                                            <ion-icon name="md-remove"></ion-icon>
                                        </ion-button>
                
                                        <div class="qtn-with-item">
                                            <span>{{"global.quantity" | translate}}</span>
                                            <h5 class="AQA-item-qty">{{orderManager.getQuantity(item)}}</h5>
                
                                        </div>
                                        <ion-button fill="clear" size="small" class="btn-qty-add AQA-add-button">
                                            <ion-icon name="md-add"></ion-icon>
                                        </ion-button>
                
                                    </div>
                
                                </div>
                                <div class="item-info">
                                    <div class="item-price" *ngIf="!settings.hideZeroItemPrice || item.price > 0">
                                        <span *ngIf="!item.minPrice" class="itemPrice-text">
                                            {{orderManager?.store?.currencySign}}
                                            {{item | itemPrice}}
                                        </span>
                                        <span *ngIf="item.minPrice" class="itemPrice-text">
                                            {{orderManager?.store?.currencySign}}{{ item.minPrice | number : '1.0-2'}}{{"global.up" | translate}}
                                        </span>
                                        <!-- <span>{{orderManager?.store?.currencySign}}{{item.price | number : '1.0-2'}}</span> -->
                                        <ion-icon *ngIf="isSet(item)" class="icon-next" name="ios-arrow-forward"></ion-icon>
                                    </div>
                                    <div class="item-title">
                                        {{getItemName(item)}}
                                    </div>
                
                                </div>
                            </ion-card>
                        </ion-col>
                    </ion-row>
                </ion-grid>

                <div class="theme1" padding slot="fixed" class="float-ft-toolbar">
                    <ion-button expand="block" (click)="cartClicked()" class="btn-order-panel">
                        <div class="footer-panel-counter">
                            <ion-badge [ngClass]="{'animated popped' : isBounce}" class="badge-item">{{orderManager.count}}
                                <span>{{"global.no-of-items" | translate}}</span>
                            </ion-badge>
                            <span>
                                {{"global.checkout" | translate}}
                                <ng-container *ngIf="settings && !settings.hidePrice">
                                    {{orderManager?.store?.currencySign}}{{orderManager?.order?.grandTotal}}
                                </ng-container>
                            </span>
                        </div>
                        <ion-icon slot="start" name="ios-arrow-forward"></ion-icon>
                    </ion-button>
                </div>
                
                
                <ion-infinite-scroll [hidden]="infiniteIsHidden" threshold="-20px" (ionInfinite)="loadMoreItems($event)">
                    <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Loading more data...">
                    </ion-infinite-scroll-content>
                </ion-infinite-scroll>
                
            </div>
        </div>
    </ng-container>

    
    

</ion-content>

<!--<ion-footer *ngIf="inApp">

    <ion-toolbar no-padding>

        <ion-button ion-button slot="start" expand="block" size="large" (click)="cartClicked()">
            <ion-icon name="arrow-round-forward"></ion-icon>{{"global.order-icon" | translate}}
            <ion-badge color="danger" margin-left [ngClass]="{'animated shake' : isBounce}">{{orderService.count}}</ion-badge>
        </ion-button>

    </ion-toolbar>


</ion-footer>-->

<ion-footer [ngClass]="{'hasItem': orderManager.count > 0}" class="abs-footer">
    <ion-button expand="block" (click)="cartClicked()"
        class="AQA-key-button key-btn-box order-btn full-btn-shadow AQA-checkout-button">
        <ion-chip [ngClass]="{'animated popped' : isBounce}" class="item-count-chip">
            <ion-label>{{orderManager.count}}</ion-label>
        </ion-chip>
        <p class="checkout-text">
            {{"global.checkout" | translate}}
            <ng-container *ngIf="settings && !settings.hidePrice && !systemConfigService.hidePriceItemGridCart">
                {{orderManager?.store?.currencySign ===  '€' ? '' : orderManager?.store?.currencySign}}
                {{orderManager?.order?.grandTotal | number : '1.0-2'}}
                {{orderManager?.store?.currencySign === '€' ? '€' : ''}}
            </ng-container>
        </p>
        <ion-icon slot="end" name="ios-arrow-forward"></ion-icon>
    </ion-button>
</ion-footer>
